import React from 'react';
import { Link } from 'react-router-dom';

function BoneMarrow() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Bone Marrow Transplant Abroad: The Ultimate Medical Tourism Cost & Quality Guide
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          Facing complex hematological conditions such as leukemia, lymphoma, multiple myeloma, or severe aplastic anemia demands immediate access to advanced cellular therapies. However, skyrocketing domestic healthcare premiums, lack of specialized local infrastructure, or long donor waiting list delays often push families to explore global options. 
          By utilizing independent informational directories like <strong>Medical Trip World</strong>, international patients can research top-tier, internationally accredited oncology networks to save up to <strong>70%</strong> on life-saving Bone Marrow Transplants (BMT) without sacrificing sterile processing safeguards or clinical expertise.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/submit-query" style={{ 
          background: '#28a745', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Request Free BMT Cost Comparison Charts & Toolkits →
        </Link>
      </div>

      {/* SECTION 1: OVERVIEW OF PROCEDURES */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Understanding Types of Bone Marrow Transplants (Hematopoietic Stem Cell Transplantation)
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '15px', fontSize: '0.95rem' }}>
          When reviewing global destinations for advanced hematology care, patients typically look up two main variations of stem cell transplantation based on the donor source:
        </p>
        <ul style={{ paddingLeft: '20px', color: '#444', lineHeight: '1.8', fontSize: '0.95rem' }}>
          <li>
            <strong>Autologous Bone Marrow Transplant:</strong> A procedure where the patient’s own healthy stem cells are harvested, frozen, and stored before undergoing high-dose chemotherapy or radiation. Once oncology cycles conclude, these cells are re-infused into the bloodstream to rebuild healthy marrow.
          </li>
          <li>
            <strong>Allogeneic Bone Marrow Transplant:</strong> A highly complex procedure utilizing healthy stem cells harvested from a matching donor—often a relative (matched related donor) or an anonymous individual found through global registries (matched unrelated donor). This includes advanced half-match variations known as **Haploidentical Transplants**.
          </li>
        </ul>
      </section>

      {/* SECTION 2: SEO COST MAGNET GRID - MOBILE PROTECTED */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Estimated Global Costs: Bone Marrow Transplant Comparison
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Financial planning is a cornerstone of oncology travel due to extended isolation stay timelines. The cost profiles outlined below reflect estimated out-of-pocket ranges synthesized from public healthcare records and historic medical tourism studies across leading global treatment regions:
        </p>

        <div style={{ background: '#f4f8fb', padding: 'clamp(12px, 4vw, 20px)', margin: '25px 0', borderRadius: '4px', borderLeft: '4px solid #005ba1' }}>
          <h3 style={{ marginTop: '0', color: '#005ba1', fontSize: '1.2rem', marginBottom: '10px' }}>📊 Estimated BMT Cost Profiles (USD):</h3>
          
          {/* Scrollable Container Protective Box */}
          <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch', margin: '15px 0 5px 0' }}>
            <table style={{ width: '100%', minWidth: '650px', borderCollapse: 'collapse', color: '#333', textAlign: 'left', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #ddd' }}>
                  <th style={{ padding: '10px 8px' }}>Transplant Category</th>
                  <th style={{ padding: '10px 8px' }}>United States (US)</th>
                  <th style={{ padding: '10px 8px' }}>United Kingdom (UK)</th>
                  <th style={{ padding: '10px 8px', color: '#28a745' }}>Global Facilitation Range</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Autologous BMT</strong></td>
                  <td style={{ padding: '10px 8px' }}>$150,000 - $250,000</td>
                  <td style={{ padding: '10px 8px' }}>$70,000 - $90,000</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#28a745' }}>$15,000 - $22,000</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Allogeneic BMT (Matched Related)</strong></td>
                  <td style={{ padding: '10px 8px' }}>$400,000 - $800,000+</td>
                  <td style={{ padding: '10px 8px' }}>$150,000 - $200,000</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#28a745' }}>$25,000 - $40,000</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <p style={{ margin: '10px 0 0 0', fontSize: '0.8rem', color: '#666', lineHeight: '1.5' }}>
            <em>*Disclaimer Notice: The pricing benchmarks outlined above serve informational purposes only. Final quotes depend strictly on specific hospital selection, diagnostic tissue typing, international donor registry fees (if applicable), necessary length of ICU stay, and post-transplant medication regimens.</em>
          </p>
        </div>
      </section>

      {/* SECTION 3: BMT QUALITY & ISOLATION SAFETY - ADAPTIVE GRID */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Critical Infrastructure Metrics for Overseas BMT Facilities
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because a bone marrow transplant temporarily reduces a patient's immune system to zero, choosing a facility with top-tier safety standards is non-negotiable. Medical Trip World acts purely as an independent reference platform, and we strongly advocate that families evaluate institutions based on these specific clinical metrics:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '15px', background: '#fafafa', borderRadius: '4px', border: '1px solid #eee' }}>
            <h4 style={{ margin: '0 0 8px 0', color: '#0b3c5d', fontSize: '1.05rem' }}>HEPA-Filtered Positive Pressure Units</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Verify that the oncology wing features strict positive-pressure isolation rooms equipped with advanced High-Efficiency Particulate Air (HEPA) filtration lines. This is critical to shield neutropenic patients from airborne contaminants during the engraftment phase.
            </p>
          </div>
          <div style={{ padding: '15px', background: '#fafafa', borderRadius: '4px', border: '1px solid #eee' }}>
            <h4 style={{ margin: '0 0 8px 0', color: '#0b3c5d', fontSize: '1.05rem' }}>In-House Stem Cell Processing Labs</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Leading international destination hospitals utilize state-of-the-art cryopreservation labs and flow cytometry infrastructure on-site, allowing immediate processing, quality checking, and secure storage of harvested stem cells.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e0e0e0', padding: 'clamp(15px, 4vw, 20px)', borderRadius: '4px' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem' }}>
          Frequently Asked Questions (FAQs) – Bone Marrow Transplant Tourism
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>How long must a patient stay abroad for a Bone Marrow Transplant?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            BMT demands an extensive time investment. Patients typically spend 30 to 45 days in an inpatient isolation room during the conditioning and engraftment periods. Following hospital discharge, patients must stay locally for another 60 to 90 days for frequent outpatient monitoring to check for complications like Graft-versus-Host Disease (GvHD).
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>Can a family member serve as a stem cell donor at an international hospital?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Yes. Close relatives (siblings, parents, or children) can undergo Human Leukocyte Antigen (HLA) tissue typing. High-resolution HLA testing can be initiated in the patient's home country, and the data can be shared digitally with foreign clinical teams during the evaluation phase.
          </p>
        </div>
        
        <div style={{ marginBottom: '5px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>Does Medical Trip World handle direct hospital admissions or donor matching?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World is an independent informational guide and directory resource. We do not provide medical interventions, run donor registries, or maintain formal corporate partnerships or MOUs with medical networks. All clinical processing, bookings, and care contracts take place directly between the patient and their independently selected medical facility.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Begin Compiling Your Medical Travel Homework Safely</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <style>{`
            @media (max-width: 600px) {
              .footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
            }
          `}</style>
          <Link to="/submit-query" className="footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            Submit General Information Request
          </Link>
          <Link to="/compare-costs" className="footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default BoneMarrow;